module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-how-we-teach-dd5eb974e64d397579e364baa84b4882.png";